import secret_eyes from '../assets/secret_eyes.zip';
import una_mattina from '../assets/una_mattina.zip';
import victoryday from '../assets/victoryday.zip';
import matanzas from '../assets/matanzas.zip';
import traicionera from '../assets/traicionera.zip';
import seekers from '../assets/seekers.zip';
import fallinforyou from '../assets/fallinforyou.zip';
import anotheronevibesthedusk from '../assets/anotheronevibesthedusk.zip';
import myownway from '../assets/myownway.zip';
import tegusta from '../assets/tegusta.zip';
import throughtime from '../assets/throughtime.zip';
import lovehope from '../assets/lovehope.zip';
import caribbean from '../assets/caribbean.zip';
import buddha_bar_ii from '../assets/buddha_bar_ii.zip';
import la_obsession from '../assets/la_obsession.zip';
import rain_in_october from '../assets/rain_in_october.zip';
import sands_of_time from '../assets/sands_of_time.zip';
import the_king_of_egypt_resurrection from '../assets/the_king_of_egypt_resurrection.zip';
import liberty_opera_voice from '../assets/liberty_opera_voice.zip';
import obses_me from '../assets/obses_me.zip';
import buddha_bar from '../assets/buddha_bar.zip';

const songs = [
	{
		"title": "Secret Eyes (عيونُكِ سرٌّ)",
		"length": 262,
		"artwork": {
			"s": "images/secret-eyes-72x72.jpg",
			"m": "images/secret-eyes-512x512.jpg"
		},
		"source": secret_eyes,
		"year": "2026",
		"url": "secret-eyes"
	},
	{
		"title": "Una Mattina",
		"length": 266,
		"artwork": {
			"s": "images/una-mattina-72x72.jpg",
			"m": "images/una-mattina-512x512.jpg"
		},
		"source": una_mattina,
		"year": "2026",
		"url": "una-mattina"
	},
	{
		"title": "Victory Day",
		"length": 165,
		"artwork": {
			"s": "images/victoryday-72x72.jpg",
			"m": "images/victoryday-512x512.jpg"
		},
		"source": victoryday,
		"year": "2026",
		"url": "victory-day"
	},
	{
		"title": "Matanzas",
		"length": 234,
		"artwork": {
			"s": "images/matanzas-72x72.jpg",
			"m": "images/matanzas-512x512.jpg"
		},
		"source": matanzas,
		"year": "2025",
		"url": "matanzas"
	},
	{
		"title": "Traicionera",
		"length": 144,
		"artwork": {
			"s": "images/traicionera-72x72.jpg",
			"m": "images/traicionera-512x512.jpg"
		},
		"source": traicionera,
		"year": "2025",
		"url": "traicionera"
	},
	{
		"title": "Seekers",
		"length": 161,
		"artwork": {
			"s": "images/seekers-72x72.jpg",
			"m": "images/seekers-512x512.jpg"
		},
		"source": seekers,
		"year": "2025",
		"url": "seekers"
	},
	{
		"title": "Fallin For You",
		"length": 182,
		"artwork": {
			"s": "images/fallin-for-you-72x72.jpg",
			"m": "images/fallin-for-you-512x512.jpg"
		},
		"source": fallinforyou,
		"year": "2024",
		"url": "fallin-for-you"
	},
	{
		"title": "Another One Vibes the Dusk",
		"length": 157,
		"artwork": {
			"s": "images/another-one-vibes-the-dusk-72x72.jpg",
			"m": "images/another-one-vibes-the-dusk-512x512.jpg"
		},
		"source": anotheronevibesthedusk,
		"year": "2024",
		"url": "another-one-vibes-the-dusk"
	},
	{
		"title": "My Own Way",
		"length": 163,
		"artwork": {
			"s": "images/my-own-way-72x72.jpg",
			"m": "images/my-own-way-512x512.jpg"
		},
		"source": myownway,
		"year": "2024",
		"url": "my-own-way"
	},
	{
		"title": "Te Gusta",
		"length": 175,
		"artwork": {
			"s": "images/te-gusta-72x72.jpg",
			"m": "images/te-gusta-512x512.jpg"
		},
		"source": tegusta,
		"year": "2024",
		"url": "te-gusta"
	},
	{
		"title": "Through Time",
		"length": 235,
		"artwork": {
			"s": "images/through-time-72x72.jpg",
			"m": "images/through-time-512x512.jpg"
		},
		"source": throughtime,
		"year": "2024",
		"url": "through-time"
	},
	{
		"title": "Love & Hope",
		"length": 218,
		"artwork": {
			"s": "images/love-hope-72x72.jpg",
			"m": "images/love-hope-512x512.jpg"
		},
		"source": lovehope,
		"year": "2024",
		"url": "love-hope"
	},
	{
		"title": "Caribbean",
		"length": 238,
		"artwork": {
			"s": "images/caribbean-72x72.jpg",
			"m": "images/caribbean-512x512.jpg"
		},
		"source": caribbean,
		"year": "2024",
		"url": "caribbean"
	},
	{
		"title": "Buddha-Bar II",
		"length": 237,
		"artwork": {
			"s": "images/buddha-bar-2-72x72.jpg",
			"m": "images/buddha-bar-2-512x512.jpg"
		},
		"source": buddha_bar_ii,
		"year": "2017",
		"url": "buddha-bar-ii"
	},
	{
		"title": "LA Obsession",
		"length": 224,
		"artwork": {
			"s": "images/la-obsession-72x72.jpg",
			"m": "images/la-obsession-512x512.jpg"
		},
		"source": la_obsession,
		"year": "2013",
		"url": "la-obsession"
	},
	{
		"title": "Rain in October",
		"length": 240,
		"artwork": {
			"s": "images/rain-in-october-72x72.jpg",
			"m": "images/rain-in-october-512x512.jpg"
		},
		"source": rain_in_october,
		"year": "2012",
		"url": "rain-in-october"
	},
	{
		"title": "Sands of Time",
		"length": 259,
		"artwork": {
			"s": "images/sands-of-time-72x72.jpg",
			"m": "images/sands-of-time-512x512.jpg"
		},
		"source": sands_of_time,
		"year": "2010",
		"url": "sands-of-time"
	},
	{
		"title": "The King of Egypt Resurrection",
		"length": 281,
		"artwork": {
			"s": "images/the-king-of-egypt-resurrection-72x72.jpg",
			"m": "images/the-king-of-egypt-resurrection-512x512.jpg"
		},
		"source": the_king_of_egypt_resurrection,
		"year": "2009",
		"url": "the-king-of-egypt-resurrection"
	},
	{
		"title": "Liberty (opera voice)",
		"length": 260,
		"artwork": {
			"s": "images/liberty-opera-voice-72x72.jpg",
			"m": "images/liberty-opera-voice-512x512.jpg"
		},
		"source": liberty_opera_voice,
		"year": "2009",
		"url": "liberty-opera-voice"
	},
	{
		"title": "Obses Me",
		"length": 247,
		"artwork": {
			"s": "images/obses-me-72x72.jpg",
			"m": "images/obses-me-512x512.jpg"
		},
		"source": obses_me,
		"year": "2009",
		"url": "obses-me"
	},
	{
		"title": "Buddha-Bar",
		"length": 264,
		"artwork": {
			"s": "images/buddha-bar-72x72.jpg",
			"m": "images/buddha-bar-512x512.jpg"
		},
		"source": buddha_bar,
		"year": "2007",
		"url": "buddha-bar"
	}
]

export default songs;
